import { render, staticRenderFns } from "./product-details.vue?vue&type=template&id=fa754158&scoped=true"
import script from "./product-details.vue?vue&type=script&lang=js"
export * from "./product-details.vue?vue&type=script&lang=js"
import style0 from "./product-details.vue?vue&type=style&index=0&id=fa754158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa754158",
  null
  
)

export default component.exports